import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseTimeMinute extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseTimeMinute {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseTimeMinute;

  public mode() {
    return TEDParseDateTimeMode.pdmHM;
  }
}
